import Vue from 'vue';
import * as actions from './actions';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'auth0',
		state: {
			isAuthenticated: false,
			currentAccount: null,
			userAccounts: null,
			loading: true,
			user: null,
			auth0Client: null,
			error: null,
			authToken: null,
			signedOut: false
		},
		getters: {
			user: state => state.user,
			isLoading: state => state.loading,
			email: state => state?.user?.email,
			isAuthenticated: state => state?.isAuthenticated,
			currentAccount: state => state?.currentAccount,
			accounts: state => state?.userAccounts
		},
		actions,
		mutations: {
			SET_AUTH0_STATE: (state, data) => {
				state.auth0Client = data.auth0Client;
				state.error = data.error;
				state.user = data.user;
				state.authToken = data.authToken;
				state.isAuthenticated = data.isAuthenticated;
				state.loading = data.loading;
			},
			LOG_OUT: state => {
				state.currentAccount = null;
				state.userAccounts = null;
				state.isAuthenticated = undefined;
				state.user = null;
				state.authToken = null;
				state.signedOut = true;
			}
		}
	});
}
